import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';
import * as Server from "./Server.js"
import QueryDialog from './DisplayURLDialog.js';
import ImagineDialog from './ImagineDialog.js';
import ListItemIcon from '@mui/material/ListItemIcon';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import {label} from './Dictionary.js';
import {theme_info} from './theme.js';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import LinkIcon from '@mui/icons-material/Link';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import LiveStatus from './LiveStatus.js';
import Checkbox from '@mui/material/Checkbox';
import RepeatIcon from '@mui/icons-material/Repeat';
import RepeatOneIcon from '@mui/icons-material/RepeatOne';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: 'rgb(230,230,230)',
    ...theme.typography.body2,
    padding: theme.spacing(0),
    marginBottom: 10,
    textAlign: 'left',
    color: theme.palette.text.secondary,
    ...theme.applyStyles('dark', {
      backgroundColor: '#1A2027',
    }),
  }));

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });

const empty_queue = {items:[], next_item:0, id_current: null, id_next: null}

function Playlist({set_battery_level_fn}) {

    const [playlist, setPlaylist] = React.useState(null);
    const [image_cache, setImageCache] = React.useState({});
    const [config, setConfig] = React.useState({});
    const [next_check_time_24_hrs, setNextCheckTime24Hrs] = React.useState("3:00");
    const [isActionDialogOpen, setActionDialogOpen] = React.useState(false);
    const [isWakeDialogOpen, setWakeDialogOpen] = React.useState(false);
    const [isImagineDialogOpen, setImagineDialogOpen] = React.useState(false);
    const [currentImageURL, setCurrentImageURL] = React.useState("");
    const [isLoading, setLoading] = React.useState(false); 
    const searchParams = new URLSearchParams(document.location.search);
    const refActiveItem = React.useRef(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const isMenuOpen = Boolean(anchorEl);
  
    function updateDeviceList()
    {
        Server.GetDeviceDetails(searchParams.get("device_id"))
        .then((res) => {
            set_battery_level_fn(res.data.battery_level, res.data.status)
           // console.log(res.data.playlist)
            setPlaylist(res.data.playlist)
            setImageCache(res.data.image_cache)
            setNextCheckTime24Hrs(res.data.next_scheduled_check_time_24_hrs)
            setConfig(res.data.config)
            setCurrentImageURL(res.data.current_image_url);
        })
        .catch((err) => setPlaylist(empty_queue));        
    }

    React.useEffect(() => {
        window.addEventListener("focus", function(){
            updateDeviceList();
        })        
        updateDeviceList();
    }, []);

    React.useEffect(() => {
        if (refActiveItem.current) 
            refActiveItem.current.scrollIntoView();
    }, [playlist]);

    function onDeleteClicked(id) {
        // Prevent rescroll
        refActiveItem.current = undefined
        Server.RemovePlaylistItemByID(searchParams.get("device_id"), id).then(() => {
            updateDeviceList();
        });
    }
    
    function onDeleteOnPlayToggle(event, id) {
        // Prevent rescroll
        refActiveItem.current = undefined
        let config = {delete_on_play: event.target.checked}
        Server.SetPlaylistItemConfigByID(searchParams.get("device_id"), id, config).then(() => {
            updateDeviceList();
        });
    }

    function onAddClicked(cache_key, key) 
    {
        let device_id = searchParams.get("device_id");
        Server.GetDeviceDetails(device_id)
            .then((res) => {
                if (res.data.status == "Active") {
                    Server.AddFromImageCache(device_id, cache_key, key, false).then(()=>{
            
                        setLoading(true)
                        Server.AwaitImageChange(device_id, res.data.current_image_url).then((res)=>{
                            setLoading(false)
                            if (res == "Sleeping")
                                setWakeDialogOpen(true)
                        })

                    }).catch((err) => {
                        setLoading(false)
                    })

                } else
                    setWakeDialogOpen(true) 
            });     

    }

    function GetListItem(props) 
    {
        return (
        <Item key={props.index} sx={{backgroundColor:props.color, opacity:props.opacity,scrollMarginTop:80}} ref={props.activeItem ? refActiveItem : null}>
        <ListItem sx={{backgroundColor:props.title_color}} disablePadding>
            <img height={30}/>
            <ListItemText sx={{position: "absolute", color: props.subtitle_color, fontSize: 4, marginLeft: 1, right: 10, top: 0}}><Typography variant="subtitle2">{props.subtitle}</Typography></ListItemText>
            <ListItemText sx={{position: "absolute", color: props.subtitle_color, fontSize: 4, marginRight: 1, left: 10, top: 0}}><Typography sx={{fontWeight: 600}} variant="subtitle2">{props.subtitle2}</Typography></ListItemText>
            <div style={{position:"absolute", right:0, bottom:5}}>
            </div>
        </ListItem>
        <ListItem disablePadding>
            <img 
                src={props.image_url} 
                height={150}
                loading="lazy"
                onClick={()=>{onAddClicked(props.cache_key, props.key)}}
            />
            {props.link ? <a href={props.text} target="_blank"><ListItemText style={{marginLeft:10}}>{props.text}</ListItemText></a> : <ListItemText style={{marginLeft:10}}>{props.text}</ListItemText>}
            <div style={{position:"absolute", right:5, top:5}}>
            <Checkbox key={props.index} checked={props.delete_on_play} onChange={(event) =>{onDeleteOnPlayToggle(event, props.id)}} icon={<RepeatIcon />} checkedIcon={<RepeatOneIcon sx={{color:"rgb(100,100,100)"}}/>} />
            </div>
            <div style={{position:"absolute", right:5, bottom:5}}>
            <IconButton onClick={props.delete_handler}>
                <DeleteIcon />
            </IconButton>
            </div>
        </ListItem>
        </Item>
        )
    }
 
    if (!playlist)
        return (<></>);

    const listItems = playlist.items.map((item, index) => {

        let props = {delete_handler: ()=> {onDeleteClicked(item.id)}}
        props.delete_on_play = item.delete_on_play ? true : false
        props.id = item.id;
        if (!item.disabled && item.playlist) {
            let sub_item = item.playlist.items.find(elem => elem.id === item.playlist.id_next)
            if (sub_item) {
                if (image_cache[item.image_collection] && typeof(image_cache[item.image_collection].items[sub_item.image_id]) == "object") {
                    props.image_url = image_cache[item.image_collection].items[sub_item.image_id][config.orientation].thumb_url
                    props.device_image_url = image_cache[item.image_collection].items[sub_item.image_id][config.orientation].url
                    props.cache_key = item.image_collection
                    props.key = sub_item.image_id
                }
            }
        }

        props.index = index;
        props.color = "rgb(220,220,220)"
        props.title_color = "rgb(200,200,200)"
        if (item.type=="imagine") {
            props.subtitle2 = label("ID_AIImage") + " (" + item.image_count + " " +  label("ID_remaining") +")"
        } else if (item.type=="upload") {
            props.subtitle2 = label("ID_DisplayImage")
        } else if (item.type=="render_url") {
            props.subtitle2 = label("ID_DisplayURL")
        }

        if (item.disabled) {
            props.subtitle = item.disabled_reason
            props.subtitle_color = "rgb(255,0,0)"
            props.opacity = 0.5;
        } else {
            if (index < playlist.next_item-1)
                props.opacity = 0.5;
            if (playlist.id_current == item.id) {
                if (props.device_image_url==currentImageURL) {
                    props.color = "rgb(240,220,220)"
                    props.title_color = "rgb(220,200,200)"
                    props.subtitle = label("ID_OnDisplay")
                    props.activeItem = true
                } else
                    props.opacity = 0.5;
            } else if (playlist.id_next == item.id) {
                // Convert to 12hour format
                props.subtitle = label("ID_UpNext") + " (" + Server.TimeFormat24To12(next_check_time_24_hrs) + ")"
            }
        }

        if (item.type == "imagine")
            return GetListItem({...props, text:"\"" + item.prompt + "\""})
        else if (item.type == "upload")
            return GetListItem({...props, text:""})
        else if (item.type == "render_url") {
            if (!item.name)
                props.link = true;
            props.image_url = item.thumb_url
            return GetListItem({...props, text: item.thumb_url ? item.name : item.url})
        }

    });

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleRenderURL = (mode) => {
        setActionDialogOpen(true)

    }

    const handleImagine = (mode) => {
        setImagineDialogOpen(true)

    }

    const handleRenderURLSubmit = (prompt) => {
        setActionDialogOpen(false)
        Server.AddRenderURL(searchParams.get("device_id"), prompt, true).then(()=>{
            updateDeviceList();
        })
    }

    const handleImagineSubmit = (prompt, images_to_generate) => {
        setImagineDialogOpen(false)
        Server.AddImagine(searchParams.get("device_id"), prompt, images_to_generate, true).then(()=>{
            updateDeviceList();
        })
    }

    const handleDialogClose = () => {
        setActionDialogOpen(false)
        setImagineDialogOpen(false)
    }    

    const handleUpload = (event) => {
        handleMenuClose();
        setLoading(true)
        Server.AddUpload(searchParams.get("device_id"), event.target.files[0], true)
        .then((response) => response.json())
        .then((result) => {
            console.log('Success:', result);
            updateDeviceList();
        })
        .catch((error) => {
            console.error('Error:', error);
        }).finally(()=>{
            handleMenuClose();
            setLoading(false)
        });

    };

    const loadingProgressStyle = {
        color: "rgb(255,255,255)"
      }

    const fabStyle = {
        position: 'fixed',
        bottom: 100,
        right: 30,
        backgroundColor: theme_info("accent_color")
      };

    return (
        <>
        <LiveStatus isLoading={isLoading} isNeedsWake={isWakeDialogOpen} onWakeDialogClick={()=>{setWakeDialogOpen(false)}}></LiveStatus>
        <Fab sx={fabStyle} color="primary" aria-label="add" onClick={handleClick}>
        <AddIcon />
        </Fab>
        <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={isMenuOpen}
                onClose={handleMenuClose}
                MenuListProps={{
                'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem component="label" ><ListItemIcon><CloudUploadIcon /></ListItemIcon><ListItemText>{label("ID_UploadFromDevice")}</ListItemText>
                <VisuallyHiddenInput
                    type="file"
                    onChange={handleUpload}
                    accept="image/*;capture=camera"
                />                
                </MenuItem>
                <MenuItem onClick={()=>{handleMenuClose(); handleRenderURL()}}><ListItemIcon><LinkIcon /></ListItemIcon><ListItemText>{label("ID_DisplayURL")}</ListItemText></MenuItem>
                <MenuItem onClick={()=>{handleMenuClose(); handleImagine(); }}><ListItemIcon><AutoFixHighIcon /></ListItemIcon><ListItemText>{label("ID_AIImage")}</ListItemText></MenuItem>


        </Menu>  
        { listItems.length==0 ? (
            <>
           <Card sx={{ maxWidth: 445 }}>
            <CardContent>
            <Typography gutterBottom variant="h5" component="div">
            {label("ID_Playlist")}
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            {label("ID_EmptyPlaylistMessage").substring(0,label("ID_EmptyPlaylistMessage").indexOf("%1"))}
            <AddCircleIcon sx={{ color: theme_info("accent_color"), fontSize: 20, position:'relative', top:4 }} />
            {label("ID_EmptyPlaylistMessage").substring(label("ID_EmptyPlaylistMessage").indexOf("%1")+2)}
            </Typography>
            </CardContent>
            </Card>
            </>
        ) : (
            <>
            <List disablePadding>
            {listItems}
            </List>
            <Box sx={{height:`140px`}}/>
            </>
        )}
        <QueryDialog open={isActionDialogOpen} title={label("ID_DisplayURL")} prompt={label("ID_EnterTheURL")} handleSubmit={handleRenderURLSubmit} handleClose={handleDialogClose} OKButtonTitle={label("ID_AddToPlaylist")}/>
        <ImagineDialog open={isImagineDialogOpen} handleSubmit={handleImagineSubmit} handleClose={handleDialogClose} showImageCount={true} OKButtonTitle={label("ID_AddToPlaylist")}/>
        </>
    );
}


export default Playlist;

/*
<Typography sx={{ marginBottom: 2 }}>
These are the devices
</Typography>
*/